/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Defines the owner responsible for actioning on a task.
 */
export enum ActionOwner {
  HOMEOWNER = 'homeowner',
  INSTALLER = 'installer',
  OPS = 'ops',
  FINANCE = 'finance',
  CONTRACTOR = 'contractor',
  PROGRAM = 'program',
  PE = 'pe',
  PARTNER_MANAGER = 'partner_manager',
  PROGRAM_MANAGER = 'program_manager',
}
